import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../common/api';
import { APIEndPoints } from '../common/endPoint';

export const getListWebTeams = createAsyncThunk(
    'getListWebTeams',
    async ({ pageParam = 1, size = 10, search }) => {
  
      const obj = {
        url: `${APIEndPoints.TeamsAPI}/list?page=${pageParam}&page_size=${size}&query=${search ? search : ''}`,
        method: 'GET',
      };
      return await API(obj);
    }
  );

export const getListWebReportedTeams = createAsyncThunk(
    'getListWebReportedTeams',
    async ({ pageParam = 1, size = 10, search }) => {
  
      const obj = {
        url: `${APIEndPoints.ReportAPI}/team/list?page=${pageParam}&page_size=${size}&query=${search ? search : ''}`,
        method: 'GET',
      };
      return await API(obj);
    }
  );

  export const updateTeamsStatus = createAsyncThunk(
    'updateTeamsStatus',
    async (body) => {
      const obj = {
        url: `${APIEndPoints.TeamsAPI}/list`,
        method: 'PUT',
        body:JSON.stringify(body)
      };
      return await API(obj);
    }
  );


  